export const rolesandpermission = [
  {
    id: "1",
    rolename: "ADMIN",
    createdon: "17 Mai 2025",
    status : "Active"
  },
  {
    id: "2",
    rolename: "MANAGER",
    createdon: "17 Mai 2025",
    status : "Active"
  },
  {
    id: "3",
    rolename: "ASSISTANT MANAGER",
    createdon: "17 Mai 2025",
    status : "Active"
  },
  {
    id: "4",
    rolename: "SELLER",
    createdon: "17 Mai 2025",
    status : "Active"
  },
  //  {
  //   id: "5",
  //   rolename: "SUPER ADMIN",
  //   createdon: "17 Mai 2024",
  //   status : "Inactive"
  // },
];
